<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Add Featured Offer</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->

      <div class="container-fluid">
        <div class="row">
          <Sidebar />
          <!-- /aside -->

          <div class="col-lg-10">
            <div class="isotope-wrapper">
              <div class="box_general padding_bottom">
                <form @submit.prevent="addfeatured()" method="post">
                  <div class="row">
                    <div class="col-md-12 add_top_30">
                      <div class="row">
                        <div class="col-md-3">
                          <div class="form-group">
                            <label>Expire Date</label>
                            <date-picker
                              v-model="expire_date"
                              :config="datepickerconfig"
                              required
                            ></date-picker>
                          </div>
                        </div>
                        <div class="col-md-9">
                          <div class="form-group">
                            <label>Choose Offer</label>
                            <select
                    class="form-control  select2"
                    v-model="offersend"
                    required
                  >
                    <option selected value="">-Select Offer-</option>
                    <option :value="offer.id" v-for="offer in offers" :key="offer.id">{{offer.short_description}}</option>
                  </select>
                          </div>
                        </div>
                       
                      </div>
                      <!-- /row-->

                      <!-- /row-->
                      <div class="row">
                        <div class="col-md-12">
                          <alert
                            transition="slide-y-transition"
                            v-if="msg"
                            :msg="msg"
                            :classAlert="classAlert"
                          ></alert>

                          <div id="pass-info" class="clearfix"></div>
                          <center>
                            <button
                              type="submit"
                              class="btn_1 rounded add_top_30 mb-3"
                            >
                              Submit
                            </button>
                          </center>
                        </div>
                      </div>
                      <!-- /row-->
                    </div>
                  </div>
                </form>
              </div>
              <!-- /row -->
            </div>
            <!-- /isotope-wrapper -->
          </div>
          <!-- /col -->
        </div>
      </div>

      <!-- /container -->
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
// import axios from 'axios'
import Alert from "@/cmps/Alert";
import API from "@/services/index";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
import Sidebar from "@/layouts/Sidebar.vue";
import moment from "moment";

export default {
  data() {
    return {
      roleId: localStorage.getItem("role_id"),
      token: "Bearer " + localStorage.getItem("token"),
      msg: null,
      expire_date : this.frontEndDateFormat(new Date(new Date().setDate(new Date().getDate() + 7))),
      offers:[],
      offersend:'',
      classAlert: null,
       datepickerconfig: {
        format: "DD/MM/YYYY",
        useCurrent: false,
        minDate: new Date().setDate(new Date().getDate() + 7)
      
      },

      login_id: null,



    };
  },
  components: {
    Frontendlayout,
    Sidebar,
    Alert,
  },
  beforeMount() {
    this.checkToken();
    this.ShowList();
  },

  methods: {
    checkToken() {
      //alert(this.token);
      if (this.token == "Bearer " + null) {
        this.$router.push("/signin");
      }
    },
   
    frontEndDateFormat(date) {
      //alert(moment(date, "YYYY-MM-DD").format("DD-MM-YYYY"));
      return moment(date, "DD-MM-YYYY").format("MM-DD-YYYY");
    },
    backEndDateFormat: function (date) {
      return moment(date, "DD-MM-YYYY").format("DD-MM-YYYY");
    },
    ShowList () {
      //alert(this.search.is_active);
      const token = "Bearer " + localStorage.getItem("token");
      const role_id = localStorage.getItem("role_id");
      const form = new FormData();
      form.append("role_id", role_id);
      form.append("search", JSON.stringify(this.search));
      //var data = { role_id: role_id, search: this.search };
      API.post("offer/get_offer_no_featured", form, {
        headers: { Authorization: token },
      })
        .then((response) => {
         
          this.offers = response.data.data
        })
        .catch((error) => {
          console.log(error);
        });
    },

    addfeatured() {
      const form = new FormData();
      form.append("expiredate", this.backEndDateFormat(this.expire_date));
      form.append("serviceprice",'isfeatured');

      API.post("/Banner/getserviceprice", form, {
        headers: { Authorization: this.token },
      })
        .then((res) => {

          this.$swal({
        title: 'Are you sure!',
        text: res.data,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes proceed to featured offer",
        closeOnConfirm: false,
      }).then((isConfirm) => {
  

        if (!isConfirm.isConfirmed) {

          this.$router.push("/featured-add/");
          return false;
        }else {

      const form = new FormData();
      form.append("expiredate", this.backEndDateFormat(this.expire_date));
      form.append("offersend", this.offersend);
      form.append("role_id", 2);
    
      API.post("/Banner/addfeatured", form, {
        headers: { Authorization: this.token },
      })
        .then((res) => {
          if (res.data.status == 200) {       
            this.$swal(res.data.messages);
            this.$router.push("/featured-list")
          } else {
            this.msg = res.data.messages;
            this.classAlert = "danger";
          }
        })
        .catch((err) => {
          this.msg = err.response.data.messages.error;
          setTimeout(() => {
            this.msg = "";
          }, 3000);
          this.classAlert = "danger";
        });
      //axios
    }
  });

        })
     
      
},

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
      this.profile_img = files[0];
    },
    onGalleryChange() {
      this.files= this.$refs.file.files;
    },
    createImage(file) {
      this.image = new Image();
      var reader = new FileReader();

      reader.onload = (e) => {
        this.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>
<style  scoped>
@import "../../public/frontend/vendor/dropzone.css";

.show_img,
.header_box img {
  width: 100%;
}
</style>